<script>
export const group = 'Bottom'
</script>

<script setup>
import TextSlideUp from './text_animations/TextSlideUp.vue'
import CharacterEnlarge from './text_animations/CharacterEnlarge.vue'
import CharacterJumpFromTheRight from './text_animations/CharacterJumpFromTheRight.vue'
import { computed } from 'vue'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const timelineSubtitle = ref(null)
const timelineSubtitleOut = ref(null)
const timelineTitle = ref(null)
const timelineNextAttempt = ref(null)

const scoreIconsElement = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'EscapeRoomScoreSmall' })
    .add(timelineTitle)
    .add(timelineSubtitle, `<${frames(14)}`)
    .add(timelineNextAttempt, `<${frames(4)}`)
    .from(scoreIconsElement.value.children, { scale: 0, opacity: 0, yPercent: 50, duration: frames(14), transformOrigin: 'center center', stagger: frames(3), ease: 'back.out' }, '<')
})

const { onDisappear } = useDisappearable()
onDisappear(async () => {
  timelineTitle.value.reverse()
  timelineNextAttempt.value.reverse()

  await gsapTimeline({ name: 'EscapeRoomScoreSmall - End' })
    .to(scoreIconsElement.value.children, { scale: 0, opacity: 0, yPercent: 50, duration: frames(10), transformOrigin: 'center center', stagger: -1 * frames(2), ease: 'back.in' }, '<')
    .add(timelineSubtitleOut.value(), '<')
    .add(timelineNextAttempt, '<')
    .add(timelineTitle, '<')
})

const mostRecentAttempt = computed(() => item.enrichment.mostRecentAttempt)
const nextAttempt = computed(() => item.enrichment.nextAttempt)
</script>

<template>
  <div class="absolute bottom-0 p-safe z-10 w-full flex justify-between items-end">
    <div class="text-white space-y-2 flex flex-col items-start">
      <div>
        <TextSlideUp
          :text="`${mostRecentAttempt.correctAnswers} ${mostRecentAttempt.correctAnswers === 1 ? 'track' : 'tracks'} gekraakt`"
          class="text-[4rem] font-bold leading-none text-q-cr-red-primary"
          @timeline="timelineSubtitle = $event"
          @timelineOut="timelineSubtitleOut = $event"
        />
        <CharacterJumpFromTheRight :text="`Muzikale Code`" class="text-white mb-1" @timeline="timelineTitle = $event" />
      </div>
      <CharacterEnlarge
        :text="nextAttempt ? `De volgende poging is ${nextAttempt.humanReadableDate}` : ''"
        class="text-white font-cervo font-bold text-[3rem]"
        @timeline="timelineNextAttempt = $event"
      />
    </div>
    <div ref="scoreIconsElement" class="flex">
      <svg v-for="i in mostRecentAttempt.correctAnswers" :key="`correct-${i}`" viewBox="0 0 24 24" stroke-width="1.5" class="fill-none stroke-current text-white size-32">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
      </svg>
      <svg v-for="i in 4 - mostRecentAttempt.correctAnswers" :key="`incorrect-${i}`" viewBox="0 0 24 24" stroke-width="1.5" class="fill-none stroke-current text-q-cr-red-primary size-32">
        <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
      </svg>
    </div>
  </div>
</template>
